var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { c } from '@debbie/cortex/dist';
import * as updatesLib from '@debbie/cortex/dist/api/updates';
import { Modal, Button, Input } from '.';
const NewUpdateTypeModal = (props) => {
    const { onToggle, onCreate, createDetails } = props;
    const lang = useSelector((s) => s.lang);
    const [loading, setLoading] = useState(false);
    const [newUpdateTypeLabel, setNewUpdateTypeLabel] = useState('');
    return (React.createElement(Modal, { header: lang.updateTypesSettings.addUpdateType, onToggle: () => onToggle(), maxWidth: "300px" },
        React.createElement(Input, { placeholder: lang.updateTypesSettings.title, value: newUpdateTypeLabel, autofocus: true, onChange: (e) => {
                setNewUpdateTypeLabel(e.target.value);
            }, onKeyDown: (e) => __awaiter(void 0, void 0, void 0, function* () {
                if (e.key === 'Enter' && newUpdateTypeLabel && !loading) {
                    setLoading(true);
                    try {
                        const newUpdate = yield updatesLib.createType(Object.assign({ label: newUpdateTypeLabel }, createDetails));
                        yield c.updates.types();
                        yield onCreate(newUpdate);
                    }
                    catch (error) {
                        console.error(error);
                        alert('Error');
                    }
                    setLoading(false);
                }
            }) }),
        React.createElement(Button, { loading: loading, block: true, disabled: !newUpdateTypeLabel, onClick: () => __awaiter(void 0, void 0, void 0, function* () {
                setLoading(true);
                try {
                    const newUpdate = yield updatesLib.createType({
                        label: newUpdateTypeLabel,
                    });
                    yield c.updates.types();
                    yield onCreate(newUpdate);
                }
                catch (error) {
                    console.error(error);
                    alert('Error');
                }
                setLoading(false);
            }) }, lang.updateTypesSettings.addUpdateType)));
};
export default NewUpdateTypeModal;
//# sourceMappingURL=CreateUpdateTypeModal.js.map